import { z } from 'zod';
import { communicationsCustomerPortalProjectIntakeSubmittedEventName } from './communications-system-notification-adapter.contract.js';
export { communicationsCustomerPortalProjectIntakeSubmittedEventName };
// Consumer-owned duplicate of the minimized Customer Portal wire contract.
// Communications imports no Customer Portal implementation or tables, so either
// optional package remains removable.
export const communicationsCustomerPortalIntakeNotificationIntentsCapability = 'communications.customer-portal-intake-notification-intents.v1';
export const communicationsCustomerPortalProjectIntakeSubmittedPayloadSchema = z.strictObject({
    intakeRequestId: z.string().uuid(),
    projectId: z.string().uuid(),
    createdByMembershipId: z.string().uuid(),
    submissionId: z.string().uuid(),
    submissionRevision: z.number().int().positive(),
    submissionHash: z.string().regex(/^[a-f0-9]{64}$/),
    assetCount: z.literal(0),
});
//# sourceMappingURL=communications-customer-portal-intake.contract.js.map